import { Component, Injector } from '@angular/core';
import type { OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import type { ModalOptions } from '@ionic/angular';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { DocumentsService } from '@shared/services';
import { RadioModalPage, ViewBasePage } from '@shared/pages';
import { Constants } from '@shared/models';
// import type { TDocument, Documents } from '@shared/models';
import type { TDocument } from '@shared/models';

// public document: TDocument = {
//     'domain': '',
//     'viewName': '',
//     'uid': ''
// };

@Component({
    'selector': 'app-documents',
    'templateUrl': './document.page.html',
    'styleUrls': ['./document.page.scss'],
    'standalone': true,
    'imports': [IonicModule, CommonModule, FormsModule]
})
export class DocumentPage extends ViewBasePage implements OnInit {
    public document: TDocument;
    private uid = '';

    constructor(private documentsService: DocumentsService, private activatedRoute: ActivatedRoute,
        private location: Location, injector: Injector) {
        super(injector);
    }

    public override ngOnInit() {
        const uid = this.activatedRoute.snapshot.paramMap.get('uid');
        this.uid = uid.replace(/'/g, '');

        // console.log('uid = ', this.uid);
        if (this.uid) {
            this.loadDocument();
        }
    }

    private async loadDocument(): Promise<void> {
        try {
            await this.uxHelperService.showSpinner();
            this.document = await this.documentsService.getByUid(this.uid) as TDocument;
            // console.log(this.document);
        } catch (err) {
            await this.uxHelperService.hideSpinner();
            const errorMessage = this.utilsService.extractError(err);
            await this.uxHelperService.showAlert('Error', errorMessage);
        } finally {
            await this.uxHelperService.hideSpinner();
        }
    }

    public onToggleDomainChange($event) {
        const domain = $event.detail.value;
        this.document.domain = domain;
        this.computeUid();
    }

    private computeUid() {
        this.document.uid = `${this.document.domain}_${this.document.viewName}`;
    }

    public async onDocumentClick() {
        const documents = Constants.Documents.map(m => m.documentName);

        const options: ModalOptions = {
            component: RadioModalPage,
            componentProps: { 'items': documents, 'selectedItem': this.document.documentName, 'title': 'Select Document' },
            backdropDismiss: false,
            showBackdrop: true,
            cssClass: 'myModalSize'
        };

        const myModal = await this.modalController.create(options);
        await myModal.present();
        const response: any = await myModal.onDidDismiss();
        if (response.data.okay) {
            this.document.documentName = response.data.selectedItem;
            const doc = Constants.Documents.find(d => d.documentName === this.document.documentName);
            this.document.viewName = doc.viewName;
            this.computeUid();
        }
    }

    public onLoadDefaultTemplateClick() {
        this.document.contents =
            `<div class="container">
    <p class="title">All Aboard Message</p>
    <p class="subtitle">Purpose:</p>
    <p>
        The [viewname] will 
    </p>

    <p class="subtitle">[Section Title1]:</p>
    <ul>
        <li>
            <span class="line1">[Item1]</span><br />
            <span class="line2">Item 1 description.</span>
        </li>
    </ul>

    <p class="subtitle">[Section Title2]:</p>
    <p>
        This is content.
    </p>

    <p class="subtitle">Instructions:</p>
    <ol>
        <li>Step 1...</li>
        <li>Step 2...</li>
        <li>Step 3...</li>    
    </ol>
</div>`
    }

    public async onSaveClick() {
        try {
            await this.uxHelperService.showSpinner();
            await this.documentsService.set(this.document);
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            await this.uxHelperService.showAlert('Error', errorMessage);
        } finally {
            await this.uxHelperService.hideSpinner();
            this.location.back();
        }
    }
}
